export default __webpack_public_path__ + "static/media/petajavesi.dbf199fc.jpeg";